import React, { useEffect, useRef, useState } from "react";
import { Blurhash } from "react-blurhash";

const DEFAULT_BLURHASH = "LEHV6nWB2yk8pyo0adR*.7kCMdnj";

const ProgressiveImage = ({
  src,
  alt,
  className = "",
  loading = "lazy",
  hash = DEFAULT_BLURHASH,
  ...props
}) => {
  const [loaded, setLoaded] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    setLoaded(false);
    const image = imageRef.current;
    if (image?.complete && image.naturalWidth > 0) setLoaded(true);
  }, [src]);

  return (
    <div className={`progressive-image ${className}`.trim()}>
      {!loaded && (
        <Blurhash
          className="blurhash-placeholder"
          hash={hash}
          width="100%"
          height="100%"
          resolutionX={32}
          resolutionY={32}
          punch={1.1}
          aria-hidden="true"
        />
      )}
      <img
        ref={imageRef}
        src={src}
        alt={alt}
        loading={loading}
        className={loaded ? "is-loaded" : ""}
        onLoad={() => setLoaded(true)}
        {...props}
      />
    </div>
  );
};

export default ProgressiveImage;
